import React from "react";
import { render } from "react-dom";
import ReactModal from "react-modal";
import { config } from "@src/config";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import "@ugc-ui/lego/styles.css";
import "../styles/fonts.css";
import "../styles/reset.css";
import "../styles/classes.css";
import { App } from "./App";

if (config.VITE_APP_SENTRY_DSN && config.VITE_APP_SENTRY_DSN !== "local") {
  Sentry.init({
    dsn: config.VITE_APP_SENTRY_DSN as string,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    sampleRate: 0.2,
    environment: config.ENVIRONMENT,
  });
}

ReactModal.setAppElement("#root");

const container = document.getElementById("root");

render(<App />, container);
